"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _lotteryAssistant = require("@/api/lotteryAssistant");
var _permission = require("@/utils/permission");
var _enums = require("../activity/enums");
var _index = _interopRequireDefault(require("@/components/RightToolbar/index.vue"));
var _dayjs = _interopRequireDefault(require("dayjs"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'LotteryAssistantRecord',
  components: {
    RightToolbar: _index.default
  },
  data: function data() {
    return {
      todayDate: (0, _dayjs.default)().format('YYYY-MM-DD'),
      loading: false,
      statisticData: {
        participantCount: 0,
        participationCount: 0,
        avgFrequency: 0
      }
    };
  },
  computed: {
    formData: function formData() {
      return [{
        label: '活动编号',
        prop: 'activityId',
        defaultValue: '',
        type: 'input'
      }, {
        label: '用户ID',
        prop: 'userId',
        defaultValue: '',
        type: 'input'
      }, {
        label: '手机号',
        prop: 'phoneNumber',
        defaultValue: '',
        type: 'input'
      }, {
        label: '兑奖码',
        prop: 'redeemCode',
        defaultValue: '',
        type: 'input'
      }, {
        label: '抽奖日期',
        prop: 'createTime',
        defaultValue: ["".concat(this.todayDate, " 00:00:00"), "".concat(this.todayDate, " 23:59:59")],
        type: 'datetimeRange',
        options: {
          startKey: 'startTime',
          endKey: 'endTime',
          startPlaceholder: '开始日期',
          endPlaceholder: '结束日期'
        }
      }];
    },
    columns: function columns() {
      return [{
        key: 'activityId',
        visible: true,
        label: "\u6D3B\u52A8\u7F16\u53F7",
        width: 160
      }, {
        key: 'activityName',
        visible: true,
        label: "\u6D3B\u52A8\u540D\u79F0",
        width: 120
      }, {
        key: 'drawTime',
        visible: true,
        label: "\u62BD\u5956\u65F6\u95F4",
        width: 160
      }, {
        key: 'prizeName',
        visible: true,
        label: "\u5956\u54C1\u540D\u79F0",
        width: 120
      }, {
        key: 'prizeType',
        visible: true,
        label: "\u5956\u54C1\u7C7B\u578B",
        width: 100,
        formatter: 'text',
        formatOptions: {
          list: _enums.prizeTypeOptions
        }
      }, {
        key: 'redeemCode',
        visible: true,
        label: "\u5151\u5956\u7801",
        width: 100
      }, {
        key: 'prizeStatusStr',
        visible: true,
        label: "\u5956\u54C1\u72B6\u6001",
        width: 100
      }, {
        key: 'expireTime',
        visible: true,
        label: "\u8FC7\u671F\u65F6\u95F4",
        width: 160
      }, {
        key: 'userId',
        visible: true,
        label: "\u7528\u6237ID",
        width: 100
      }, {
        key: 'phoneNumber',
        visible: true,
        label: "\u624B\u673A\u53F7",
        width: 120
      }];
    }
  },
  created: function created() {},
  methods: {
    checkPermi: _permission.checkPermi,
    handleSearch: function handleSearch(e) {
      var _this = this;
      // 查询参与人数、参与人次、人均频次
      var params = _objectSpread({}, e);
      (0, _lotteryAssistant.lotteryRecordStatisticApi)(params).then(function (data) {
        var _data$participantCoun = data.participantCount,
          participantCount = _data$participantCoun === void 0 ? 0 : _data$participantCoun,
          _data$participationCo = data.participationCount,
          participationCount = _data$participationCo === void 0 ? 0 : _data$participationCo,
          _data$avgFrequency = data.avgFrequency,
          avgFrequency = _data$avgFrequency === void 0 ? 0 : _data$avgFrequency;
        _this.statisticData.participantCount = participantCount;
        _this.statisticData.participationCount = participationCount;
        _this.statisticData.avgFrequency = avgFrequency;
      });
    },
    refreshList: function refreshList() {
      this.$refs.searchPage && this.$refs.searchPage.refresh();
    },
    resetList: function resetList() {
      this.$refs.searchPage && this.$refs.searchPage.resetSearch();
    },
    getList: function getList(query, sortMap) {
      var params = _objectSpread({}, query);
      return (0, _lotteryAssistant.lotteryRecordListApi)(params).then(function (data) {
        var list = (data.list || []).map(function (item) {
          return item;
        });
        return {
          list: list,
          total: data.total
        };
      });
    },
    handleStatus: function handleStatus(row) {
      var _this2 = this;
      this.$modalSure("\u786E\u5B9A\u8981\u53D1\u653E\u5956\u54C1\"".concat(row.prizeName, "\"\u7ED9\u7528\u6237\u5417\uFF1F")).then(function () {
        var params = {
          recordId: row.recordId,
          prizeStatus: 1
        };
        (0, _lotteryAssistant.lotteryRecordSetStatusApi)(params).then(function (res) {
          _this2.$message.success('发放成功');
          _this2.getList();
        }).catch(function () {
          _this2.$message.error('发放失败');
        });
      }).catch(function () {
        // 取消发放，不做任何操作
      });
    }
  }
};